import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ParticipantState } from './types';
import { SampleKit, StoreStatus } from '../../core/types/common.types';
import { linkParticipantAndSampleThunk, participantThunk } from './thunks';

// Initial State
const initialState: ParticipantState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
  sampleKit: null,
  sampleLink: null,
};

// Slice
export const participantSearchSlice = createSlice({
  name: 'participant',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
    setSampleKit: (state, action: PayloadAction<SampleKit | null>) => {
      state.sampleKit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(participantThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(participantThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = {
        ...action.payload,
      };
      state.sampleKit = null;
      state.errors = null;
    });

    builder.addCase(participantThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });

    builder.addCase(linkParticipantAndSampleThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(linkParticipantAndSampleThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.sampleLink = {
        ...action.payload,
      };
      state.errors = null;
    });

    builder.addCase(linkParticipantAndSampleThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.sampleLink = null;
    });
  },
});

// Action creators
export const { reset, setSampleKit } = participantSearchSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default participantSearchSlice.reducer;
